import {
    Grid,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Table,
    Paper
} from '@mui/material'
import { useTranslation } from 'react-i18next';

import { AMOUNT_LOCALE } from '../i18n';

const PYG_SYMBOL              = 'PY₲';


export default function IRPCalculationDetail({calculatedTaxes}) {
    const { t }         = useTranslation();
    const formatter     = Intl.NumberFormat(AMOUNT_LOCALE);
    let totalTaxes      = 0;

    calculatedTaxes.forEach(row => {
        totalTaxes += row.amount;
    })

    return (
    <Grid container sx={{p: 1}}> 
        <TableContainer component={Paper} >
        <Table sx={{ minWidth: 200 }} aria-label="spanning table">
            <TableHead>
            <TableRow>
                <TableCell colSpan={2}><strong>{t('detail.bracket')}</strong></TableCell>
                <TableCell align="right"><strong>{t('detail.amount', { currency: PYG_SYMBOL })}</strong></TableCell>
            </TableRow>
            </TableHead>

            <TableBody>
                
            {calculatedTaxes.map((row) => (
                <TableRow key={row.percent_tax}>
                <TableCell colSpan={2}>{row.percent_tax}%</TableCell>
                <TableCell align="right">{formatter.format(row.amount)}</TableCell>
                </TableRow>
            ))}

            <TableRow>
                <TableCell colSpan={2} align="right"><i>{t('detail.total')}</i></TableCell>
                <TableCell align="right"><i>{formatter.format(totalTaxes)}</i></TableCell>
            </TableRow>
            
            </TableBody>
        </Table>
    </TableContainer>
   </Grid>
    );
}
